import * as THREE from 'three/build/three.module.js';
import {mergeVertices} from 'three/examples/jsm/utils/BufferGeometryUtils.js';
import {dragControls} from './drags-lite-beta.js';
import {keyControls} from './keys.js';

import * as naked_vars from "./sandwich-vars.js";
import {menu} from "../../../object-menu/modules/fantastic-menu.js";

const vars = new Proxy(naked_vars.variables, menu.handler);

let scene, model, light, renderer, view_grid, root_plane, view_axes, view_bounds, view_user, r_root_plane, LT_unit;
let render_l_date;

const objects = {};
const ray_caster = new THREE.Raycaster();
ray_caster.params = {
    Line: {threshold: 1},
    Points: {threshold: 3.0},
}

const vk = new THREE.Vector3(0, 0, 0);
const vw = new THREE.Vector3(0, 0, 0);
const vu = new THREE.Vector3(0, 0, 0);
const vc = new THREE.Vector3(0, 0, 0);
const mu = new THREE.Matrix4();

const y_up = new THREE.Vector3(0, 1, 0);
const x_right = new THREE.Vector3(1, 0, 0);
const z_in = new THREE.Vector3(0, 0, 1);
const instance_obj_temp = new THREE.Object3D();

const obs_menu = document.getElementById('obs-menu');
const obs = document.getElementById('obs');

const cam = {
    camera: null,
    default_z: 10,
    default_reset_z: 10,
    base_pos: vars.cam.base_pos,  ///new THREE.Vector3(0, 0, 20),
    pos: vars.cam.pos,
    projected: new THREE.Vector3(0, 0, 0),
    event_origin: new THREE.Vector3(0, 0, 0),
    distance: 1.0,
    min_zoom: 0.25,
    scale: 1.0,
    cube: null,
    frustum: new THREE.Frustum(),
    frustum_mat: new THREE.Matrix4(),
    direction: new THREE.Vector3(0, 0, 0),
    right: new THREE.Vector3(0, 0, 0),
    dot_x: new THREE.Vector3(0, 0, 0),
    dot_y: new THREE.Vector3(0, 0, 0),
    dot_z: new THREE.Vector3(0, 0, 0),
    run() {
        vu.copy(cam.base_pos).applyQuaternion(cam.cube.quaternion);
        cam.pos.copy(vu);
        //cam.pos.lerp(cam.base_pos.clone().applyQuaternion(cam.cube.quaternion), 0.1);
        vu.copy(y_up).applyQuaternion(cam.cube.quaternion);
        cam.camera.up.copy(vu);

        cam.camera.position.copy(cam.pos);
        //cam.camera.up.lerp(y_up.clone().applyQuaternion(cam.cube.quaternion), 0.1);
        // vu.addVectors(cam.pos, user.position.actual);
        //
        // cam.camera.position.copy(vu);//lerp(vu, 0.1);
        // cam.camera.position.copy(cam.pos);//, user.position.actual);
        vu.set(0,0,0);
        cam.camera.lookAt(vu);//user.position.actual);
        // cam.camera.updateMatrix();
        // cam.camera.updateMatrixWorld();

        cam.frustum.setFromProjectionMatrix(cam.frustum_mat.multiplyMatrices(cam.camera.projectionMatrix, cam.camera.matrixWorldInverse));
        cam.camera.getWorldDirection(vu);
        cam.direction.copy(vu);
        cam.right.crossVectors(vu, cam.camera.up);
        cam.dot_y = cam.camera.up.dot(root_plane.normal);
        cam.dot_x = cam.right.dot(x_right);
        cam.dot_z = z_in.dot(vu);


        //vw.subVectors(cam.camera.position, user.position.actual);
        cam.distance = cam.camera.position.length();//vw.length();

        cam.camera.updateMatrix();
        cam.camera.updateMatrixWorld();
        cam.camera.updateProjectionMatrix();
    }
}

const cube_box = new THREE.BoxGeometry(2, 2, 2);
cam.cube = new THREE.Mesh(cube_box, new THREE.MeshStandardMaterial({color: 0xffffff}));
cam.cube.updateMatrix();
cam.cube.userData.originalMatrix = cam.cube.matrix.clone();

vars.pos = new THREE.Vector3(0, 0, 0);
vars.mouse_plane_pos = new THREE.Vector3(0, 0, 0);
vars.mouse_map_pos = new THREE.Vector3(0, 0, 0);
vars.mouse_delta = new THREE.Vector3(0, 0, 0);
vars.mouse_origin = new THREE.Vector3(0, 0, 0);

function fuct_menu_checkbox(name){

    function element_event(e, force=null){
        if(force !== null){
            wel.state = force;
        }else{
            wel.state = !wel.state;
            vars[wel.label] = wel.state;
        }

        wel.check_off.style.display = ['none','block'][+wel.state];
        wel.check_on.style.display = ['none','block'][+!wel.state];
    }

    function init_element(){
        const label = document.createElement('div');
        label.textContent = wel.label;
        label.style.display = 'inline-block';
        wel.domel.addEventListener('mouseup', element_event);
        wel.check_off.style.display = ['none','block'][+wel.state];
        wel.check_on.style.display = ['none','block'][+!wel.state];
        wel.check.appendChild(wel.check_on);
        wel.check.appendChild(wel.check_off);
        wel.check.style.display = 'inline-block';
        wel.domel.appendChild(wel.check);
        wel.domel.appendChild(label);

        vars[wel.label] = wel.state;
    }

    const wel = {
        label:name,
        state: vars[name],
        check_on: document.getElementById("check-box-0").cloneNode(true),
        check_off: document.getElementById("check-box-1").cloneNode(true),
        check: document.createElement('div'),
        domel: document.createElement('div'),
        element_event
    }

    init_element();

    return wel;
}

const paused_checkbox = fuct_menu_checkbox('paused');
const gravity_checkbox = fuct_menu_checkbox('gravity');
obs.textContent = '';
obs.appendChild(paused_checkbox.domel);
obs.appendChild(gravity_checkbox.domel);


function get_vector(plane, n, v, sx, sy){
    vc.copy(cam.camera.position);//pos).add(user.position.actual);//camera.position);//pos).add(user.position.actual);
    user.util_plane.set(plane, 0.0);// n === 1 ? -user.position.actual.x : -user.position.actual.y);

    vu.set(vars.view.width / 2 + sx, vars.view.height / 2 + sy, 0.0);
    vu.x = ((vu.x / vars.view.width) * 2 - 1);
    vu.y = (-(vu.y / vars.view.height) * 2 + 1);
    vu.unproject(cam.camera);
    //
    v.copy(vu).sub(vc).normalize();
    ray_caster.ray.set(vc, v);
    // ray_caster.setFromCamera(vu, cam.camera);
    ray_caster.ray.intersectPlane(user.util_plane, v);
}

function get_intersections(plane, n, v, p1, p2){
    p1.project(cam.camera);
    const p1x = (vars.view.width / 2 - ((p1.x + 1) * vars.view.width / 2)) *-1;
    const p1y = (vars.view.height / 2 - (-(p1.y - 1) * vars.view.height / 2)) *-1;
    p2.project(cam.camera);
    const p2x = (vars.view.width / 2 - ((p2.x + 1) * vars.view.width / 2)) *-1;
    const p2y = (vars.view.height / 2 - (-(p2.y - 1) * vars.view.height / 2)) *-1;
    const pko = [{v:null,l:null},{v:null,l:null}];

    vw.copy(v);
    vw.project(cam.camera);
    vw.x = (vw.x + 1) * vars.view.width / 2;
    vw.y = -(vw.y - 1) * vars.view.height / 2;
    const xa = (vars.view.width / 2 - vw.x) * -1;
    const ya = (vars.view.height / 2 - vw.y) * -1;

    const o_angle = Math.atan2(ya,xa);//ffs
    const p1ke = p1x*Math.tan(o_angle);
    const p2ke = p2x*Math.tan(o_angle);
    const p1kv = p1y/Math.tan(o_angle);
    const p2kv = p2y/Math.tan(o_angle);

    if(p1ke < p2y || p1ke > p1y){
        get_vector(plane, n, vk, p1kv, p1y);
    }else{
        get_vector(plane, n, vk, p1x, p1ke);
    }
    pko[0].v = vk.clone();
    pko[0].l = vk.length();

    if(p2ke < p2y || p2ke > p1y){
        get_vector(plane, n, vk, p2kv, p2y);
    }else{
        get_vector(plane, n, vk, p2x, p2ke);
    }
    pko[1].v = vk.clone();
    pko[1].l = vk.length();

    pko.sort((a, b) => { return a.l - b.l });

    // objects.a_help.position.copy(pko[0].v);
    // objects.b_help.position.copy(pko[1].v);
    return pko;
}

const user = {
    util_plane: new THREE.Plane(),
    position: {
        actual: vars.view.start_user_pos,
        round: new THREE.Vector3(0, 0, 0),
        dvl: new THREE.Vector3(0, 0, 0)
    },
    mouse: {
        raw: new THREE.Vector3(0, 0, 0),
        plane_pos: vars.mouse_plane_pos,
        delta_pos: vars.mouse_delta,
        map_pos: vars.mouse_map_pos,
        origin_pos: vars.mouse_origin,
        screen: null,
        state: null,
        last_down: new THREE.Vector3(0, 0, 0),
        new_down: new THREE.Vector3(0, 0, 0)
    },
    inited:false,
    sp_wid:null,
    state: false,
    toggle_state() {
        user.state = !user.state;
    },
    show() {
        //view_user.visible = false;

        //if (vars.view.show_user) view_user.position.copy(user.position.actual);


        view_user.labels.map((l, i)=>{
            l.mesh.quaternion.copy(cam.camera.quaternion);
            //l._points.quaternion.copy(cam.camera.quaternion);
            l.write(l.value+' '+(-1.0*model.position[l.value]).toFixed(2));

            //l.cube.visible = false;
            const rw = 0.5;
            const rh = 0.25;
            const parv = [0,0,0];//[user.position.actual.x, 0.0, user.position.actual.z];

            parv[i] += 10.0;

            vc.set(-rw,-rh,0);
            l.mesh.localToWorld(vc);
            vk.copy(vc);

            vc.set(rw,rh,0);
            l.mesh.localToWorld(vc);
            vw.copy(vc);

            vc.set(parv[0], parv[1], parv[2]);

            const stpko = get_intersections(i === 1 ? z_in : y_up, i, vc, vk, vw);

            // objects.marks[i].marker.position.copy(stpko[0].v.sub(user.position.actual));
            // objects.marks[i].marker2.position.copy(stpko[1].v.sub(user.position.actual));

            view_user.grid_lines.segments[i][0].position.copy(stpko[0].v);
            view_user.grid_lines.segments[i][1].position.copy(stpko[1].v);

            view_user.grid_lines.segments[i][0].geometry.computeBoundingBox();
            view_user.grid_lines.segments[i][1].geometry.computeBoundingBox();
            view_user.grid_lines.segments[i][0].geometry.computeBoundingSphere();
            view_user.grid_lines.segments[i][1].geometry.computeBoundingSphere();
            //
            // if(i === 1){
            //     objects.a_help.position.copy(stpko[0].v);//.sub(user.position.actual));
            //     objects.b_help.position.copy(stpko[1].v);//.sub(user.position.actual));
            // }
        });

        //view_user.computeBoundingBox();
        //view_user.visible = true;
    }
}

// ----- math on vector arrays -------------------------------------------------------------
// https://github.com/matthias-research/pages/blob/master/tenMinutePhysics/10-softBodies.html
// the idea is that this absolves you of having to hatch and crack the buffer attributes every time.
//
// function vecSetZero(a, anr) {
//     anr *= 3;
//     a[anr++] = 0.0;
//     a[anr++] = 0.0;
//     a[anr] = 0.0;
// }
//
// function vecScale(a, anr, scale) {
//     anr *= 3;
//     a[anr++] *= scale;
//     a[anr++] *= scale;
//     a[anr] *= scale;
// }
//
// function vecCopy(a, anr, b, bnr) {
//     anr *= 3;
//     bnr *= 3;
//     a[anr++] = b[bnr++];
//     a[anr++] = b[bnr++];
//     a[anr] = b[bnr];
// }
//
// function vecAdd(a, anr, b, bnr, scale = 1.0) {
//     anr *= 3;
//     bnr *= 3;
//     a[anr++] += b[bnr++] * scale;
//     a[anr++] += b[bnr++] * scale;
//     a[anr] += b[bnr] * scale;
// }
//
// function vecSetDiff(dst, dnr, a, anr, b, bnr, scale = 1.0) {
//     dnr *= 3;
//     anr *= 3;
//     bnr *= 3;
//     dst[dnr++] = (a[anr++] - b[bnr++]) * scale;
//     dst[dnr++] = (a[anr++] - b[bnr++]) * scale;
//     dst[dnr] = (a[anr] - b[bnr]) * scale;
// }
//
// function vecLengthSquared(a, anr) {
//     anr *= 3;
//     let a0 = a[anr], a1 = a[anr + 1], a2 = a[anr + 2];
//     return a0 * a0 + a1 * a1 + a2 * a2;
// }
//
// function vecDistSquared(a, anr, b, bnr) {
//     anr *= 3;
//     bnr *= 3;
//     let a0 = a[anr] - b[bnr], a1 = a[anr + 1] - b[bnr + 1], a2 = a[anr + 2] - b[bnr + 2];
//     return a0 * a0 + a1 * a1 + a2 * a2;
// }
//
// function vecDot(a, anr, b, bnr) {
//     anr *= 3;
//     bnr *= 3;
//     return a[anr] * b[bnr] + a[anr + 1] * b[bnr + 1] + a[anr + 2] * b[bnr + 2];
// }
//
// function vecSetCross(a, anr, b, bnr, c, cnr) {
//     anr *= 3;
//     bnr *= 3;
//     cnr *= 3;
//     a[anr++] = b[bnr + 1] * c[cnr + 2] - b[bnr + 2] * c[cnr + 1];
//     a[anr++] = b[bnr + 2] * c[cnr + 0] - b[bnr + 0] * c[cnr + 2];
//     a[anr] = b[bnr + 0] * c[cnr + 1] - b[bnr + 1] * c[cnr + 0];
// }

function quick_d(x) {
    const x2 = 0.5 * (f32[0] = x);
    u32[0] = (0x5f3759df - (u32[0] >> 1));
    let y = f32[0];
    y = y * (1.5 - (x2 * y * y));// 1st iteration
    return y;
}

function vecSet(a, anr, x, y, z) {
    anr *= 3;
    a[anr++] = x;
    a[anr++] = y;
    a[anr] = z;
}

function vecSetZero(a, anr) {
    anr *= 3;
    a[anr++] = 0.0;
    a[anr++] = 0.0;
    a[anr] = 0.0;
}

function vecScale(a, anr, scale) {
    anr *= 3;
    a[anr++] *= scale;
    a[anr++] *= scale;
    a[anr] *= scale;
}

function vecCopy(a, anr, b, bnr, scale = 1.0) {
    anr *= 3;
    bnr *= 3;
    a[anr++] = b[bnr++] * scale;
    a[anr++] = b[bnr++] * scale;
    a[anr] = b[bnr] * scale;
}

function vecAdd(a, anr, b, bnr, scale = 1.0) {
    anr *= 3;
    bnr *= 3;
    a[anr++] += b[bnr++] * scale;
    a[anr++] += b[bnr++] * scale;
    a[anr] += b[bnr] * scale;
}

function vecSetDiff(dst, dnr, a, anr, b, bnr, scale = 1.0) {
    dnr *= 3;
    anr *= 3;
    bnr *= 3;
    dst[dnr++] = (a[anr++] - b[bnr++]) * scale;
    dst[dnr++] = (a[anr++] - b[bnr++]) * scale;
    dst[dnr] = (a[anr] - b[bnr]) * scale;
}

function vecLengthSquared(a, anr) {
    anr *= 3;
    let a0 = a[anr], a1 = a[anr + 1], a2 = a[anr + 2];
    return a0 * a0 + a1 * a1 + a2 * a2;
}

function vecDistSquared(a, anr, b, bnr) {
    anr *= 3;
    bnr *= 3;
    let a0 = a[anr] - b[bnr], a1 = a[anr + 1] - b[bnr + 1], a2 = a[anr + 2] - b[bnr + 2];
    return a0 * a0 + a1 * a1 + a2 * a2;
}

function vecDot(a, anr, b, bnr) {
    anr *= 3;
    bnr *= 3;
    return a[anr] * b[bnr] + a[anr + 1] * b[bnr + 1] + a[anr + 2] * b[bnr + 2];
}

function vecSetCross(a, anr, b, bnr, c, cnr) {
    anr *= 3;
    bnr *= 3;
    cnr *= 3;
    a[anr++] = b[bnr + 1] * c[cnr + 2] - b[bnr + 2] * c[cnr + 1];
    a[anr++] = b[bnr + 2] * c[cnr + 0] - b[bnr + 0] * c[cnr + 2];
    a[anr] = b[bnr + 0] * c[cnr + 1] - b[bnr + 1] * c[cnr + 0];
}

function vecSetSum(dst,dnr, a,anr, b,bnr, scale = 1.0) {
    dnr *= 3; anr *= 3; bnr *= 3;
    dst[dnr++] = (a[anr++] + b[bnr++]) * scale;
    dst[dnr++] = (a[anr++] + b[bnr++]) * scale;
    dst[dnr]   = (a[anr] + b[bnr]) * scale;
}

function vecAggregate(dst, dnr, a, indices, normalize = false) {
    dst[dnr] = 0.0;
    dst[dnr + 1] = 0.0;
    dst[dnr + 2] = 0.0;
    for (let i of indices) vecAdd(dst, dnr, a, i);
    vecScale(dst, dnr, 1 / indices.length);
    if (normalize) vecScale(dst, dnr, quick_d(vecLengthSquared(dst, dnr)));
}

const buf = new ArrayBuffer(4);
const f32 = new Float32Array(buf)
const u32 = new Uint32Array(buf);

function unit_hash(spacing, max_count) {

    function hashCoords(xi, yi, zi) {
        let rh = (xi * 92837111) ^ (yi * 689287499) ^ (zi * 283923481);	// fantasy function
        //console.log(h);
        return Math.abs(rh) % hash.tableSize;
    }

    function intCoord(coord) {
        return Math.floor(coord / hash.spacing);
    }

    function hashPos(pos, nr) {
        return hashCoords(
            intCoord(pos[3 * nr]),
            intCoord(pos[3 * nr + 1]),
            intCoord(pos[3 * nr + 2]));
    }

    function create(pos) {
        const numObjects = Math.min(pos.length / 3, hash.cellEntries.length);
        // determine cell sizes
        hash.cellStart.fill(0);
        hash.cellEntries.fill(0);
        for (let i = 0; i < numObjects; i++) {
            const h = hashPos(pos, i);
            hash.cellStart[h]++;
        }
        // determine cells starts
        let start = 0;
        for (let i = 0; i < hash.tableSize; i++) {
            start += hash.cellStart[i];
            hash.cellStart[i] = start;
        }
        hash.cellStart[hash.tableSize] = start;	// guard
        // fill in objects ids
        for (let i = 0; i < numObjects; i++) {
            const h = hashPos(pos, i);
            hash.cellStart[h]--;
            hash.cellEntries[hash.cellStart[h]] = i;
        }
    }

    function query(pos, nr, maxDist) {
        const x0 = intCoord(pos[3 * nr] - maxDist);
        const y0 = intCoord(pos[3 * nr + 1] - maxDist);
        const z0 = intCoord(pos[3 * nr + 2] - maxDist);

        const x1 = intCoord(pos[3 * nr] + maxDist);
        const y1 = intCoord(pos[3 * nr + 1] + maxDist);
        const z1 = intCoord(pos[3 * nr + 2] + maxDist);

        hash.querySize = 0;

        for (let xi = x0; xi <= x1; xi++) {
            for (let yi = y0; yi <= y1; yi++) {
                for (let zi = z0; zi <= z1; zi++) {
                    const h = hashCoords(xi, yi, zi);
                    const start = hash.cellStart[h];
                    const end = hash.cellStart[h + 1];
                    for (let i = start; i < end; i++) {
                        hash.queryIds[hash.querySize] = hash.cellEntries[i];
                        hash.querySize++;
                    }
                }
            }
        }
    }

    function query_all(pos, maxDist) {

        let num = 0;
        const maxDist2 = maxDist * maxDist;

        for (let i = 0; i < hash.maxNumObjects; i++) {
            const id0 = i;
            hash.firstAdjId[id0] = num;
            hash.query(pos, id0, maxDist);

            for (let j = 0; j < hash.querySize; j++) {
                const id1 = hash.queryIds[j];
                if (id1 >= id0)
                    continue;
                const dist2 = vecDistSquared(pos, id0, pos, id1);
                if (dist2 > maxDist2)
                    continue;

                if (num >= hash.adjIds.length) {
                    let newIds = new Int32Array(2 * num);  // dynamic array
                    newIds.set(hash.adjIds);
                    hash.adjIds = newIds;
                }
                hash.adjIds[num++] = id1;
            }
        }

        hash.firstAdjId[hash.maxNumObjects] = num;
    }

    const hash = {
        spacing: spacing,
        tableSize: 2 * max_count + 1,
        cellStart: new Int32Array((2 * max_count) + 1),
        cellEntries: new Int32Array(max_count),
        queryIds: new Int32Array(max_count),
        querySize: 0,
        maxNumObjects: max_count,
        firstAdjId: new Int32Array(max_count + 1),
        adjIds: new Int32Array(10 * max_count),
        create,
        query,
        query_all
    }

    /*
    class Hash {
				constructor(spacing, maxNumObjects)
				{
					this.spacing = spacing;
					this.tableSize = 2 * maxNumObjects;
					this.cellStart = new Int32Array(this.tableSize + 1);
					this.cellEntries = new Int32Array(maxNumObjects);
					this.queryIds = new Int32Array(maxNumObjects);
					this.querySize = 0;
				}

				hashCoords(xi, yi, zi) {
					var h = (xi * 92837111) ^ (yi * 689287499) ^ (zi * 283923481);	// fantasy function
					return Math.abs(h) % this.tableSize;
				}

				intCoord(coord) {
					return Math.floor(coord / this.spacing);
				}

				hashPos(pos, nr) {
					return this.hashCoords(
						this.intCoord(pos[3 * nr]),
						this.intCoord(pos[3 * nr + 1]),
						this.intCoord(pos[3 * nr + 2]));
				}

				create(pos) {
					var numObjects = Math.min(pos.length / 3, this.cellEntries.length);

					// determine cell sizes

					this.cellStart.fill(0);
					this.cellEntries.fill(0);

					for (var i = 0; i < numObjects; i++) {
						var h = this.hashPos(pos, i);
						this.cellStart[h]++;
					}

					// determine cells starts

					var start = 0;
					for (var i = 0; i < this.tableSize; i++) {
						start += this.cellStart[i];
						this.cellStart[i] = start;
					}
					this.cellStart[this.tableSize] = start;	// guard

					// fill in objects ids

					for (var i = 0; i < numObjects; i++) {
						var h = this.hashPos(pos, i);
						this.cellStart[h]--;
						this.cellEntries[this.cellStart[h]] = i;
					}
				}

				query(pos, nr, maxDist) {
					var x0 = this.intCoord(pos[3 * nr] - maxDist);
					var y0 = this.intCoord(pos[3 * nr + 1] - maxDist);
					var z0 = this.intCoord(pos[3 * nr + 2] - maxDist);

					var x1 = this.intCoord(pos[3 * nr] + maxDist);
					var y1 = this.intCoord(pos[3 * nr + 1] + maxDist);
					var z1 = this.intCoord(pos[3 * nr + 2] + maxDist);

					this.querySize = 0;

					for (var xi = x0; xi <= x1; xi++) {
						for (var yi = y0; yi <= y1; yi++) {
							for (var zi = z0; zi <= z1; zi++) {
								var h = this.hashCoords(xi, yi, zi);
								var start = this.cellStart[h];
								var end = this.cellStart[h + 1];

								for (var i = start; i < end; i++) {
									this.queryIds[this.querySize] = this.cellEntries[i];
									this.querySize++;
								}
							}
						}
					}
				}
			};

    */
    return hash;
}

function units() {
    let frame = 0;
    let c_dist = null;
    let uc_dist = null;
    let code = '';
    let flow_t = 0;
    let flow_counter = 0;

    function flow(){
        if(UU.stopped) return;
        if(flow_t % 8 === 0) {
            if(flow_counter >= UU.count) flow_counter = 0;
            vecCopy(UU.pos, flow_counter, [0, UU.scene_bounds_dims[4] / 2, 0], 0); //
            //vecCopy(UU.p_pos, flow_counter, UU.pos, flow_counter);

            const vfa = [
                -UU.start_vel_amt + 2.0 * UU.start_vel_amt * Math.random(),
                -UU.start_vel_amt + 2.0 * UU.start_vel_amt * Math.random(),
                -UU.start_vel_amt + 2.0 * UU.start_vel_amt * Math.random()];
            //Math.abs(Math.sin(flow_counter/10.0))/100.0
            vecCopy(UU.vel, flow_counter, [Math.sin(flow_counter/10.0), -4.0, Math.cos(flow_counter/10.0)], 0);
            flow_counter++
        }
        flow_t++;
    }

    function get_pretty_balls(counter) {

        const mapper = {
            cartesian2polar: function (position) {
                let r = Math.sqrt(position.x * position.x + position.z * position.z + position.y * position.y);
                let x = Math.round(position.x * 10000) / 10000,
                    z = Math.round(position.z * 10000) / 10000;

                if (x === -0) {
                    x = 0;
                }
                if (z === -0) {
                    z = 0;
                }

                return ({
                    r: r,
                    phi: Math.acos(position.y / r),
                    theta: Math.atan2(z, x)
                });
            },

            polar2canvas: function (polarPoint) {
                return ({
                    y: polarPoint.phi / Math.PI,
                    x: (polarPoint.theta + Math.PI) / (2 * Math.PI)
                })
            }
        }
        //create image
        const bitmap = document.createElement('canvas');
        const g = bitmap.getContext('2d');
        bitmap.width = 1000;
        bitmap.height = 1000;
        g.fillStyle = '#f5eabf';
        g.fillRect(0, 0, bitmap.width, bitmap.height);

        g.fillStyle = 'red';
        for (let i = 1; i < 10; i += 2) {
            g.fillRect(0, i * (bitmap.height / 9), bitmap.width, (bitmap.height / 9));
        }
        g.strokeStyle = 'black';
        g.lineWidth = 10;
        g.beginPath();
        g.moveTo(0, bitmap.height/2);
        g.lineTo(bitmap.width, bitmap.height/2);
        g.stroke();

        g.beginPath();
        g.moveTo(bitmap.width/2, 0);
        g.lineTo(bitmap.width/2, bitmap.height);
        g.stroke();

        g.beginPath();
        g.moveTo(250, 0);
        g.lineTo(250, bitmap.height);
        g.stroke();

        g.beginPath();
        g.moveTo(750, 0);
        g.lineTo(750, bitmap.height);
        g.stroke();

        // canvas contents will be used for a texture
        const texture = new THREE.Texture(bitmap)
        texture.needsUpdate = true;
        //const a_geometry = new THREE.SphereBufferGeometry(UU.point_radius, 8, 8);//points, 20);
        // const a_material = new THREE.MeshStandardMaterial({
        //     // const a_material = new THREE.MeshStandardMaterial({
        //     color: 0xCCCCCC,
        //     side: THREE.FrontSide,
        //     // // gradientMap: false,
        //     // flatShading: true,
        //     roughness: 0,
        //     metalness: 0.25,
        //     emissive: 0x222200,
        //     // depthTest: true,
        //     // depthWrite: true,
        //     map: texture
        // });
        const d_material = new THREE.MeshStandardMaterial({
            color: 0xFFFFFF,
            flatShading: true,
            // emissive: 0x333333,
            roughness: 0.25,
            metalness: 0.25,
            side: THREE.FrontSide,
            wireframe:false,
            //map:texture,
        });
        // a_geometry.rotateX(Math.PI / 2);
        // a_geometry.name = 'a_geometry';


        let ico_geom = new THREE.IcosahedronGeometry(UU.point_radius*2, 2);
        const ico_vertices = [];
        const ico_pvas = new Float32Array(ico_geom.attributes.position.count * 2);


        for (let i = 0; i < ico_geom.attributes.position.count; i++) {
            let v3 = new THREE.Vector3().fromBufferAttribute(ico_geom.attributes.position, i);
            ico_vertices.push(v3);
            const uvi = mapper.polar2canvas(mapper.cartesian2polar(v3));
            ico_pvas[i * 2] = uvi.x;
            ico_pvas[i * 2 + 1] = uvi.y;
        }

        //console.log(ico_pvas);

        let c_geometry = new THREE.BufferGeometry();
        c_geometry.setAttribute('uv', new THREE.BufferAttribute(ico_pvas, 2));
        c_geometry.setFromPoints(ico_vertices);
        c_geometry = mergeVertices(c_geometry);
        // c_geometry.deleteAttribute('uv');
        c_geometry.deleteAttribute('normal');
        c_geometry.computeVertexNormals();
        c_geometry.computeBoundingSphere();
        c_geometry.computeBoundingBox();
        c_geometry.name = 'c_geometry';

        UU.balls = {};
        UU.balls.color = new Float32Array(counter*3);
        UU.balls.color.fill(1.0);


        const instance = new THREE.InstancedMesh(c_geometry, d_material, counter);
        instance.instanceMatrix.setUsage(THREE.DynamicDrawUsage);
        instance.instanceColor = new THREE.InstancedBufferAttribute(UU.balls.color, 3, false, 1);
        instance.instanceColor.setUsage(THREE.DynamicDrawUsage);
        instance.instanceMatrix.needsUpdate = true;
        instance.instanceColor.needsUpdate = true;

        // instance.castShadow = true; //default is false
        // instance.receiveShadow = true; //default
        instance.receiveShadow = true;
        instance.castShadow = true;

        instance.name = 'all';

        return instance;
    }

    function get_pretty_sectors(){
        const res = 2;
        const s = (vars.view.scene_width)*res;

        const p_material = new THREE.MeshBasicMaterial({
            color: 0xFFFFFF,
            blending: THREE.AdditiveBlending,
        });

        UU.sectors.ham = [];
        UU.sectors.color = new Float32Array(s*s*4);
        UU.sectors.color.fill(1.0);

        const p_geometry = new THREE.PlaneBufferGeometry(1/res,1/res);
        p_geometry.rotateX(Math.PI/-2);

        const p_pos = new Float32Array(s*s*3);
        p_pos.fill(0.0);

        const instance = new THREE.InstancedMesh(p_geometry, p_material, s*s);
        instance.instanceMatrix.setUsage(THREE.DynamicDrawUsage);
        instance.instanceColor = new THREE.InstancedBufferAttribute(UU.sectors.color, 4, false, 1);
        instance.instanceColor.setUsage(THREE.DynamicDrawUsage);

        for (let xi = 0; xi < s; xi++) {
            for (let zi = 0; zi < s; zi++) {
                const i = (s*xi)+zi;
                const x = (xi-((s/2)-(1/res)))/res;
                const z = (zi-((s/2)-(1/res)))/res;
                vecCopy(UU.sectors.color,i,[Math.abs(1/x),0,Math.abs(1/z),1.0],0);
                UU.matrix.makeTranslation(x,-0.025,z);
                instance.setMatrixAt((s*xi)+zi, UU.matrix);
                UU.sectors.ham.push([]);
            }
        }

        instance.instanceMatrix.needsUpdate = true;
        instance.instanceColor.needsUpdate = true;
        UU.sectors.instance = instance;

        UU.sectors.on_color = new THREE.Color(1,1,1,1);
        UU.sectors.update = function(i){
            const pos = [UU.pos[i*3],UU.pos[i*3+1],UU.pos[i*3+2]];
            const index = (s*Math.floor((pos[0]*res)+(s/2)) + Math.floor((pos[2]*res)+(s/2)));

            UU.sectors.color[index*4+3] += 1.0;
            const kc = 1.0-(0.5*((1/UU.sectors.color[index*4+3]*2)));
            UU.sectors.color[index*4] = kc;
            UU.sectors.color[index*4+1] = kc;
            UU.sectors.color[index*4+2] = kc;
        }

        scene.add(instance);
    }

    function update() {
        let uind = 0;
        let rays_counter = 0;
        if(UU.sectors.update) UU.sectors.color.fill(0.0);

        for (let i = 0; i < UU.count; i++) {
            // UU.matrix.makeTranslation(UU.pos[3 * i], UU.pos[3 * i + 1], UU.pos[3 * i + 2]);
            // UU.all.setMatrixAt(i, UU.matrix);
            //const con = UU.p_dat[i].connections;
            //if(UU.rad[i]>0.25) {
            instance_obj_temp.position.set(UU.pos[3 * i], UU.pos[3 * i + 1], UU.pos[3 * i + 2]);
            //instance_obj_temp.scale.setScalar(UU.rad[i]);///0.5 + (con.length / 12));

            // vecCopy(UU.temp, 0, UU.pos, i);
            // vecAdd(UU.temp, 0, UU.vel, i);
            // vu.set(UU.temp[0], UU.temp[1], UU.temp[2]);
            // instance_obj_temp.lookAt(vu);
            instance_obj_temp.updateMatrix();
            UU.all.setMatrixAt(uind, instance_obj_temp.matrix);

            // if (UU.draw_points){
            //     vecCopy(UU.temp, 0, UU.norm, i);
            //     vu.set(UU.temp[0], UU.temp[1], UU.temp[2]);
            //     instance_obj_temp.lookAt(vu);
            //     instance_obj_temp.updateMatrix();
            //     UU.field_points_planes.setMatrixAt(uind, instance_obj_temp.matrix);
            // }


            if(UU.sectors.update) UU.sectors.update(i);

            if(UU.artefacts && UU.p_dat[i].connect.length > 0) {
                // vecAggregate(UU.temp, 0, UU.pos, UU.p_dat[i].connect);
                // vecSetDiff(UU.temp, 0, UU.temp, 0, UU.pos, i, -1.0);
                // vecScale(UU.temp,0,0.5);
                // vecAdd(UU.temp,0,UU.pos,i,1.0);
                // UU.rays.c_connect(UU.pos,i,UU.temp,0,rays_counter);
                // vecCopy(UU.rays.colors, rays_counter, [1, 1, 0], 0);
                // vecCopy(UU.rays.colors, rays_counter + 1, [1, 1, 0], 0);
                // rays_counter += 2;
            }

            //}
            uind++;
        }



        if(UU.sectors.instance) UU.sectors.instance.instanceColor.needsUpdate = true;
        UU.all.count = uind;//geometry.setDrawRange(0,uind);
        UU.all.instanceMatrix.needsUpdate = true;
        UU.all.instanceColor.needsUpdate = true;

        if (UU.decorate){
            UU.field_points.geometry.computeBoundingBox();
            //objects.box.update();
        }
        //
        //
        //

        if (UU.draw_points) {
            UU.rays.geometry.attributes.position.needsUpdate = true;
            UU.rays.geometry.attributes.position.needsUpdate = true;
            UU.field_points_planes.instanceMatrix.needsUpdate = true;
        }
        // //mvu.addVectors(point.pos, point.m.velocity);
        // instance_obj_temp.position.copy(point.pos);//addVectors(point.pos, point.velocity);//, point.m.accel);
        // //instance_obj_temp.scale.setScalar(point.radius);\
        // //vu.addVectors(point.pos, point.velocity)
        // instance_obj_temp.lookAt(point.pre_pos);
        // instance_obj_temp.updateMatrix();
        // instance.setMatrixAt(id, instance_obj_temp.matrix);
        //instance.setColorAt(point.id, point.color);

        if(UU.artefacts) {
            //#//EDGES ROUTINE
            const k_edges = Object.keys(UU.edges);
            for (let e = 0; e < k_edges.length; e++) {
                const k_edge = UU.edges[k_edges[e]];
                if(k_edge.valid()) {
                    UU.rays.c_connect(UU.pos, k_edge.p1, UU.pos, k_edge.p2, rays_counter);
                    vecCopy(UU.rays.colors, rays_counter, [1, 1, 0], 0);
                    vecCopy(UU.rays.colors, rays_counter + 1, [1, 0, 0], 0);
                    rays_counter += 2;
                }else{
                    delete UU.edges[k_edges[e]];
                }
            }

            UU.rays.geometry.setDrawRange(0, rays_counter);
            UU.rays.geometry.computeBoundingSphere();
            UU.rays.geometry.attributes.color.needsUpdate = true;
            UU.rays.geometry.attributes.position.needsUpdate = true;
        }
    }

    function init() {
        const nice_colors = [
            168, 0, 0,
            235, 121, 0,
            235, 172, 0,
            252, 248, 0,
            108, 179, 9,
            55, 89, 6,
            1, 143, 136,
            4, 47, 66,
            45, 129, 168,
            222, 4, 215,
            163, 208, 209,
            89, 15, 97,
            217, 211, 165,
            173, 217, 165
        ];



        console.log('init UU units');
        const spacing = UU.spacing * UU.radius;
        const velRand = UU.start_vel_amt;
        const s2 = UU.bounds;
        const s3 = UU.scene_bounds;
        UU.bounds_dims = [-s2, 0.0, -s2, s2, UU.depth * s2, s2];
        UU.scene_bounds_dims = [-s3, 0.0, -s3, s3, UU.depth * s3, s3];

        const s = UU.bounds_dims;
        const numX = Math.floor((s[3] - s[0] - 2.0 * spacing) / spacing);
        const numY = Math.floor((s[4] - s[1] - 2.0 * spacing) / spacing);
        const numZ = Math.floor((s[5] - s[2] - 2.0 * spacing) / spacing);

        UU.count = numX * numY * numZ;

        UU.pos = new Float32Array(3 * UU.count);
        UU.p_pos = new Float32Array(3 * UU.count);
        UU.vel = new Float32Array(3 * UU.count);
        UU.norm = new Float32Array(3 * UU.count);
        UU.vel_len = new Float32Array(UU.count);

        UU.count = UU.pos.length / 3;
        UU.hash = unit_hash(UU.radius * 2, UU.count);

        for (let xi = 0; xi < numX; xi++) {
            for (let yi = 0; yi < numY; yi++) {
                for (let zi = 0; zi < numZ; zi++) {
                    const x = 3 * ((xi * numY + yi) * numZ + zi);
                    const y = x + 1;
                    const z = x + 2;
                    UU.pos[x] = s[0] + spacing + xi * spacing;
                    UU.pos[y] = s[1] + spacing + yi * spacing;
                    UU.pos[z] = s[2] + spacing + zi * spacing;
                    UU.vel[x] = -velRand + 2.0 * velRand * Math.random();
                    UU.vel[y] = -velRand + 2.0 * velRand * Math.random();
                    UU.vel[z] = -velRand + 2.0 * velRand * Math.random();
                }
            }
        }

        if(UU.decorate){
            const material = {
                map() {
                    const bitmap = document.createElement('canvas');
                    const g = bitmap.getContext('2d');
                    bitmap.width = 128;
                    bitmap.height = 128;

                    let circle = new Path2D();  // <<< Declaration
                    circle.arc(64, 64, 62, 0, 2 * Math.PI, false);
                    g.fillStyle = 'white';
                    g.fill(circle);

                    // canvas contents will be used for a texture
                    const texture = new THREE.Texture(bitmap);
                    texture.needsUpdate = true;
                    return texture;
                },
                points: new THREE.PointsMaterial({
                    vertexColors: true,
                    transparent: true,
                    blending: THREE.AdditiveBlending,
                    color: 0xFFFFFF,
                    size: 0.25,
                    opacity: 0.7,
                    depthTest: false,
                    depthWrite: false
                }),
            }

            const colors = [];
            for (let c = 0; c < UU.count; c++) {
                colors.push([1, 1, 0]);
            }

            const PG = new THREE.BufferGeometry();
            PG.name = 'PG';
            const PG_colors = new Float32Array([].concat(...colors));
            PG.setAttribute('position', new THREE.BufferAttribute(UU.norm, 3));
            PG.setAttribute('color', new THREE.BufferAttribute(PG_colors, 3));
            PG.deleteAttribute('normal');
            PG.deleteAttribute('uv');

            material.points.map = material.map();
            UU.field_points = new THREE.Points(PG, material.points);
            UU.field_points.name = 'field_points';

            model.add(UU.field_points);

            UU.edge_list = {};
        }

        if(UU.artefacts){
            const rays_per_vert = 12;
            UU.rays = {
                geometry: new THREE.BufferGeometry(),
                segments: new Float32Array(3 * rays_per_vert * UU.count),
                colors: new Float32Array(3 * rays_per_vert * UU.count),
                connect: (p1, p2, index) => {
                    vecCopy(UU.rays.segments, (p1 * rays_per_vert) + (index * 2), UU.pos, p1);
                    vecCopy(UU.rays.segments, (p1 * rays_per_vert + 1) + (index * 2), UU.pos, p2);
                },
                b_connect: (src1, p1, src2, p2, index) => {
                    vecCopy(UU.rays.segments, (p1 * rays_per_vert) + (index * 2), src1, p1);
                    vecCopy(UU.rays.segments, (p1 * rays_per_vert + 1) + (index * 2), src2, p2);
                },
                c_connect: (src1, p1, src2, p2, index) => {
                    vecCopy(UU.rays.segments, index, src1, p1);
                    vecCopy(UU.rays.segments, index + 1, src2, p2);
                },
                init: () => {
                    UU.rays.segments.fill(0.0);
                    UU.rays.colors.fill(1.0);
                    UU.rays.geometry.setAttribute('position', new THREE.BufferAttribute(UU.rays.segments, 3).setUsage(THREE.DynamicDrawUsage));
                    UU.rays.geometry.setAttribute('color', new THREE.BufferAttribute(UU.rays.colors, 3).setUsage(THREE.DynamicDrawUsage));
                    const rays = new THREE.LineSegments(UU.rays.geometry, new THREE.LineBasicMaterial({vertexColors: true, color: 0xFFFFFF}));
                    UU.rays.geometry.name = 'rays';
                    return rays;
                }
            }

            model.add(UU.rays.init());
        }


        console.log('UU.count', UU.count);

        UU.all = get_pretty_balls(UU.count);
        // UU.colors = new Float32Array(UU.pos.length);
        // UU.colors.fill(0.0);
        // UU.all.instanceColor = new THREE.InstancedBufferAttribute(UU.colors, 3, false, 1);

        model.add(UU.all);

        for (let i = 0; i < UU.count; i++) {
            UU.p_dat.push({query:[],connect:[]});
            vecCopy(UU.p_pos, i, UU.pos, i);
            vecCopy(UU.norm, i, UU.pos, i);
        }

        vars.point_count = UU.count;


        if(UU.decorate){
            UU.field_points.geometry.computeBoundingBox();
            // objects.box.setFromObject(UU.field_points);
            // objects.box.update();
        }else{
            //objects.box.visible = false;///();
        }


        UU.update();

        if(UU.sectors.on) get_pretty_sectors();

        if(UU.decorate) {
            UU.box_limit = 200;
            UU.boxes = [];
            UU.box_help = [];
            UU.box_colors = [];

            const rk = nice_colors.length / 3;
            let rkct = 0;

            for (let i = 0; i < UU.box_limit; i++) {
                const h_col = new THREE.Color(
                    nice_colors[rkct * 3] / 255.0,
                    nice_colors[rkct * 3 + 1] / 255.0,
                    nice_colors[rkct * 3 + 2] / 255.0
                );
                UU.box_colors.push(h_col);
                const box = new THREE.Box3();
                UU.boxes.push(box);
                const halp = new THREE.Box3Helper(box, 0xFFFFFF);
                UU.box_help.push(halp);
                scene.add(halp);

                rkct++;
                if (rkct > rk) rkct = 0;
            }
        }
    }

    function pre_move(sub_dt) {
        for (let i = 0; i < UU.count; i++) {
            if(UU.vel_len[i] < UU.active_limit) continue;
            if(UU.gravity_on) vecAdd(UU.vel, i, UU.gravity, 0, sub_dt);
            vecCopy(UU.p_pos, i, UU.pos, i);
            vecAdd(UU.pos, i, UU.vel, i, sub_dt);
            vecCopy(UU.norm, i, UU.pos, i);
        }
    }

    function solver_ground_collisions() {
        for (let i = 0; i < UU.count; i++) {
            for (let dim = 0; dim < 3; dim++) {
                const nr = 3 * i + dim;
                if (UU.pos[nr] < UU.scene_bounds_dims[dim] + UU.radius) {
                    vecSetDiff(UU.temp,0, UU.pos,i, UU.p_pos,i);
                    vecAdd(UU.pos,i, UU.temp,0, -UU.damping);
                    UU.pos[nr] = (UU.scene_bounds_dims[dim]) + UU.radius;
                    if (UU.bounce) UU.vel[nr] = -UU.vel[nr] * UU.restitution;
                }
                if (UU.pos[nr] > UU.scene_bounds_dims[dim + 3] - UU.radius) {
                    vecSetDiff(UU.temp,0, UU.pos,i, UU.p_pos,i);
                    vecAdd(UU.pos,i, UU.temp,0, -UU.damping);
                    UU.pos[nr] = (UU.scene_bounds_dims[dim + 3]) - UU.radius;
                    if (UU.bounce) UU.vel[nr] = -UU.vel[nr] * UU.restitution;
                }
            }
        }
        // if (y < 0.0) {
        //     vecCopy(this.pos,i, this.prevPos,i);
        //     this.pos[3 * i + 1] = 0.0;
        // }
    }

    function solver_move(sub_dt){
        const min_dist = (2 * UU.radius);
        const threshold = min_dist * UU.threshold;

        for (let i = 0; i < UU.count; i++) {
            const first = UU.hash.firstAdjId[i];
            const last = UU.hash.firstAdjId[i + 1];
            UU.p_dat[i].connect = [];

            for (let m = first; m < last; m++) {
                const j = UU.hash.adjIds[m];
                if (i === j) continue;
                const conn = UU.p_dat[i].connect;
                if(conn.indexOf(j) !== -1) continue;

                vecSetDiff(UU.normal, 0, UU.pos, i, UU.pos, j);
                c_dist = vecLengthSquared(UU.normal, 0);

                if (c_dist < threshold * threshold) {

                    if (c_dist < min_dist * min_dist) {
                        uc_dist = quick_d(c_dist)*c_dist;
                        vecScale(UU.normal, 0, 1.0 / uc_dist);
                        const corr = (min_dist - uc_dist) * 0.5;
                        vecAdd(UU.pos, i, UU.normal, 0, corr);
                        vecAdd(UU.pos, j, UU.normal, 0, -corr);
                    }else{
                        uc_dist = quick_d(c_dist)*c_dist;
                        vecScale(UU.normal, 0, 1.0 / uc_dist);
                        const corr = (min_dist - uc_dist) * UU.cohesion;
                        vecAdd(UU.pos, i, UU.normal, 0, corr);
                        vecAdd(UU.pos, j, UU.normal, 0, -corr);
                        if(conn.indexOf(j) === -1) UU.p_dat[i].connect.push(j);

                    }

                    vecSetDiff(UU.temp, 0, UU.pos, i, UU.p_pos, i);
                    vecSetDiff(UU.temp, 1, UU.pos, j, UU.p_pos, j);
                    // average velocity
                    vecSetSum(UU.temp, 2, UU.temp, 0, UU.temp, 1, 0.5);
                    // velocity corrections
                    vecSetDiff(UU.temp, 0, UU.temp, 2, UU.temp, 0);
                    vecSetDiff(UU.temp, 1, UU.temp, 2, UU.temp, 1);
                    // add corrections
                    vecAdd(UU.pos, i, UU.temp, 0, UU.friction);
                    vecAdd(UU.pos, j, UU.temp, 1, UU.friction);
                }
            }
        }

    }

    function grouper(){
        UU.sectors.list = [];
        UU.sectors.list_pos = [];
        UU.sectors.list_hash = new Uint16Array(UU.count).fill(-1);
        UU.rash = [];

        function reg(n){
            for (let lm = 0; lm < UU.sectors.list.length; lm++) {
                if(UU.sectors.list[lm].indexOf(n) !== -1){
                    return lm;
                }
            }
            return -1;
        }

        function dims(arr, index){
            for (let n = 0; n < 3; n++) {
                arr[n] = Math.min(arr[n],UU.pos[3*index+n]);
                arr[n+3] = Math.max(arr[n+3],UU.pos[3*index+n]);
            }
        }

        for (let i = 0; i < UU.count; i++) {
            //#// this is being set sequentially and has lapses. gnarly.
            if(!UU.p_dat[i].connect.length) continue; //has no relevant connections
            const j_i = reg(i);
            if(j_i === -1) {
                UU.sectors.list.push([i]);
                UU.sectors.list_pos.push([
                    UU.pos[3 * i],
                    UU.pos[3 * i + 1],
                    UU.pos[3 * i + 2],
                    UU.pos[3 * i],
                    UU.pos[3 * i + 1],
                    UU.pos[3 * i + 2],
                    UU.sectors.list.length,
                    i
                ]);
                //UU.rash.push([i,UU.p_dat[i].connect]);
            }else{//what if it's already in?
                for (let m = 0; m < UU.p_dat[i].connect.length; m++) {
                    const j = UU.p_dat[i].connect[m];
                    if(UU.sectors.list[j_i].indexOf(j) === -1){
                        UU.sectors.list[j_i].push(j);
                        dims(UU.sectors.list_pos[j_i],j);
                    }
                }
            }


            for (let m = 0; m < UU.p_dat[i].connect.length; m++) {
                const j = UU.p_dat[i].connect[m];
                // code = i > j ? `${j}_${i}` : `${i}_${j}`;
                // if (!UU.edges[code]) UU.edges[code] = edge(code, Math.min(i,j), Math.max(i,j));
                //if (i === j) continue;
                const j_i = reg(i);
                if(j_i !== -1){
                    if(UU.sectors.list[j_i].indexOf(j) === -1){
                        UU.sectors.list[j_i].push(j);
                        dims(UU.sectors.list_pos[j_i],j);
                    }
                }
                const j_o = reg(j);
                if(j_o !== -1) {
                    if(UU.sectors.list[j_o].indexOf(i) === -1){
                        UU.sectors.list[j_i].map(ji=>{
                            if(UU.sectors.list[j_o].indexOf(ji) === -1){
                                UU.sectors.list[j_o].push(ji);
                                dims(UU.sectors.list_pos[j_o],ji);
                            }
                        });
                        UU.sectors.list.splice(j_i,1);
                        UU.sectors.list_pos.splice(j_i,1);
                    }
                }
            }
        }

        for (let f = 0; f < UU.sectors.list.length; f++) {
            for (let g = 0; g < UU.sectors.list[f].length; g++) {
                const rage = reg(UU.sectors.list[f][g]);
                if(rage !== f){
                    UU.sectors.list[f].map(ji=> {
                        if(UU.sectors.list[rage].indexOf(ji) === -1){
                            UU.sectors.list[rage].push(ji);
                            dims(UU.sectors.list_pos[rage],ji);
                        }
                    });
                    UU.sectors.list.splice(f,1);
                    UU.sectors.list_pos.splice(f,1);
                    f--;
                    //#// issue is with deleting while iterating.
                    break;
                }
            }
        }

        if(UU.decorate) {
            UU.box_help.map(b => {
                b.visible = false;
            });

            for (let f = 0; f < UU.sectors.list.length; f++) {
                if (f >= UU.box_limit) break;
                if (UU.sectors.list_pos[f].length < 7) console.log(UU.sectors.list_pos[f]);

                UU.boxes[f].setFromArray(UU.sectors.list_pos[f].slice(0, 6));
                UU.boxes[f].expandByScalar(UU.radius);
                UU.box_help[f].visible = true;
                UU.box_help[f].material.color = UU.box_colors[f];

                UU.sectors.list[f].map(n => {
                    UU.all.setColorAt(n, UU.box_colors[f]);
                })

            }
        }
    }

    function solver_interact(sub_dt){
        for (let i = 0; i < UU.count; i++) {
            vecSetDiff(UU.normal, 0, UU.pos, i, UU.inter.pos, 0);
            c_dist = vecLengthSquared(UU.normal, 0);

            if (c_dist < UU.inter.rad * UU.inter.rad) {
                c_dist *= quick_d(c_dist);
                vecScale(UU.normal, 0, 1.0 / c_dist);
                const corr_i = (UU.inter.rad - c_dist);
                vecAdd(UU.vel, i, UU.normal, 0, corr_i*(1/sub_dt));
            }


            if(vars.events.keys.map.includes('MetaRight') || vars.events.action === 'down'){
                UU.damping = 0.1;
                c_dist *= quick_d(c_dist);
                vecScale(UU.normal, 0, 1.0 / c_dist);
                vecAdd(UU.vel, i, UU.normal, 0, -0.1/sub_dt);
            }else{
                UU.damping = 1.0;
            }
        }
    }

    function last_move(sub_dt) {
        let v_len = null;
        UU.active_count = 0;
        for (let i = 0; i < UU.count; i++) {
            vecSetDiff(UU.temp, 0, UU.pos,i, UU.p_pos, i, 1.0 / (sub_dt));
            vecAdd(UU.temp, 0, UU.vel, i);
            vecCopy(UU.vel, i, UU.temp, 0, 0.5);

            v_len = vecLengthSquared(UU.vel, i);
            v_len *= quick_d(v_len);
            UU.vel_len[i] = 1.0;//v_len;//*(1.0 / (sub_dt));
            if(UU.vel_len[i] > UU.active_limit){
                UU.active_count++;
            }
        }
    }

    function move(){

        vu.copy(user.mouse.plane_pos).setY(UU.inter.height);
        vw.copy(user.mouse.plane_pos).sub(model.position);//.add(user.mouse.plane_pos);
        //model.worldToLocal(vw);

        UU.inter.pos = vw.toArray();

        objects.arrow.position.copy(vw).setY(UU.inter.rad+1.0); //user.mouse.plane_pos
        //objects.lite.position.copy(user.mouse.plane_pos);
        objects.ball.body.position.copy(vw);

        objects.ball.update(vw, UU.inter.rad, UU.scene_bounds_dims);

        if (!UU.stopped) {
            const sdt = UU.dt / UU.num_substeps;
            const maxVelocity = 0.09 / sdt;
            UU.hash.create(UU.pos);
            const maxTravelDist = maxVelocity * UU.dt;
            UU.hash.query_all(UU.pos, maxTravelDist);

            //UU.hash.create(UU.pos);
            //pre_query();

            if (UU.inter.on) solver_interact(UU.dt);


            for (let step = 0; step < UU.num_substeps; step++) {
                pre_move(sdt);
                solver_ground_collisions();
                solver_move(sdt);
                last_move(sdt);
            }

            grouper();
            update();

            if(UU.decorate){
                UU.field_points.geometry.attributes.position.needsUpdate = true;
                UU.field_points.geometry.setDrawRange(0, UU.count);
            // }else{
            //     UU.field_points.geometry.setDrawRange(0,0);
            }
        }


        // if(vars.selected_instance !== null){
        //     const hs = Math.round(vars.selected_instance);
        //     UU.all.setColorAt(hs, UU.unit_color.active);
        //     if (UU.stopped) UU.all.instanceColor.needsUpdate = true;
        // }

        vars.static_connect = Object.keys(UU.edge_list).length;

    }

    function edge(id_str, p1, p2){

        //validate.
        const valid = () => {
            // const conn = UU.p_dat[e.p1].connect;
            // const conn2 = UU.p_dat[e.p2].connect;
            //console.log(e.id, e.p1, e.p2, conn, conn2);
            return UU.p_dat[e.p1].connect.indexOf(e.p2) !== -1 || UU.p_dat[e.p2].connect.indexOf(e.p1) !== -1;
        }

        const e = {
            p1:p1,
            p2:p2,
            id:id_str,
            valid,
        }

        return e;
    }


    //⭐️⭐️
    const UU = {
        artefacts: false,
        decorate: false,
        edge_list: {},
        selected: vars.selected_instance,
        dt: 1.0 / 60.0,
        gravity: [0, -19.6, 0], //-9.8
        gravity_on: vars.gravity,
        num_substeps: 8,
        cohesion: 0.95, //.25,// 0.0625,
        damping: 1.0,
        friction: 0.25,
        restitution: 1.0,
        depth: 2,
        spacing: 6,
        radius: 0.25,
        threshold: 1.0625,
        point_radius: 0.25,//0.0625,//0.0625,
        start_vel_amt: 12.01,
        bounce: true,
        inter:{
            rad:3.0,
            on:true,
            height:0.0,
            pos: [],
            strenth: 0.125,
        },
        sectors:{
            on:false,
        },
        active_limit: 0.125,//0.05,
        active_count: 0,
        stopped: false,
        limit:2000,
        edges: {},
        triangles: null,
        triangles_object: null,
        selecta: null,
        selecta_dat: {
            n: null
        },
        field_markers: null,
        field_triangles: null,
        field_points: null,
        field_points_alt: null,
        field_points_planes: null,
        tetras: null,
        tets: {},
        draw_tets: false,
        draw_triangles: false,
        draw_points: false,
        ray_code: [[0, 1, 0], [1, 2, 0], [2, 3, 0], [3, 0, 0], [2, 0, 1], [3, 1, 1]],
        tet_code: [0, 1, 2, 3, 2, 1, 3, 1, 0, 3, 0, 2],
        bounds: 10.0,///.0,
        scene_bounds: 20.0,///.0,
        bounds_dims: [],
        connections: [],
        p_dat: [],
        colors: null,
        unit_color: {
            base: new THREE.Color(0xCCCCCC),
            active: new THREE.Color(0xFF00FF),
            off: new THREE.Color(0x333333),
            floored: new THREE.Color(0x0000FF),
        },
        normal: new Float32Array(3),
        temp: new Float32Array(12),
        hash: null,
        matrix: new THREE.Matrix4(),
        max_xz: 5,
        // gravity: [0, -9.8, 0],
        all: null,
        pos: null,
        p_pos: null,
        vel: null,
        vel_len: null,
        norm: null,
        agg_norm: null,
        agg_norm_color: null,
        floored: null,
        triangle_colors: null,
        rad: null,
        set_rad: null,
        update,
        move,
        flow
        //units:the_units
    }

    init();

    return UU;
}

function scene_label(){

    function write(text){
        const g = label.canvas.getContext('2d');
        g.font = label.font_size+label.font;
        g.fillStyle = '#000000';//label.base_color;
        g.fillRect(0, 0, label.canvas.width, label.canvas.height);
        g.fillStyle = label.color;
        const wid = g.measureText(text).width;
        const hgt = g.measureText(text).actualBoundingBoxAscent+g.measureText(text).actualBoundingBoxDescent;
        g.fillText(text, label.size/2 - wid/2, label.size/2 + hgt/2);
        label.texture.needsUpdate = true;
    }

    function init_object(){
        label.canvas = document.createElement('canvas');
        label.canvas.width = label.size;
        label.canvas.height = label.size;
        label.texture = new THREE.Texture(label.canvas);
        label.texture.needsUpdate = true;
        //
        // const cube = new THREE.PlaneGeometry(2, 2, 2);
        // const cube_material = new THREE.MeshBasicMaterial({
        //     color: 0xFF00FF,
        //     transparent: true,
        //     opacity: 0.5,
        //     wireFrame: true,
        //     side: THREE.DoubleSide,
        // });
        //
        // const marker = new THREE.SphereGeometry(0.0625);
        // const marker_material = new THREE.MeshBasicMaterial({
        //     color: 0xFF00FF,
        // });
        //
        //
        // label.cube = new THREE.Mesh(cube, cube_material);
        //
        //
        // label.marker = new THREE.Mesh(marker, marker_material);
        // label.marker2 = new THREE.Mesh(marker, marker_material);
        //
        // const geometry = new THREE.PlaneGeometry(1,1);
        //
        // const material = new THREE.MeshBasicMaterial({
        //     transparent: true,
        //     blending: THREE.AdditiveBlending,
        //     opacity: 0.5,
        //     side: THREE.DoubleSide,
        //     map: label.texture,
        //     depthTest: false,
        //     depthWrite: false
        // });
        //
        // const pram = [
        //     -1,1,0,
        //     1,1,0,
        //     1,-1,0,
        //     -1,-1,0,
        //     // -1,1,1,
        //     // 1,1,1,
        //     // 1,-1,1,
        //     // -1,-1,1
        // ]
        //
        // label.pos = new Float32Array(pram);
        // const PG = new THREE.BufferGeometry();
        //
        // const pg_material = {
        //     map() {
        //         const bitmap = document.createElement('canvas');
        //         const g = bitmap.getContext('2d');
        //         bitmap.width = 128;
        //         bitmap.height = 128;
        //
        //         let circle = new Path2D();  // <<< Declaration
        //         circle.arc(64, 64, 62, 0, 2 * Math.PI, false);
        //         g.fillStyle = 'white';
        //         g.fill(circle);
        //
        //         // canvas contents will be used for a texture
        //         const texture = new THREE.Texture(bitmap);
        //         texture.needsUpdate = true;
        //         return texture;
        //     },
        //     points: new THREE.PointsMaterial({
        //         transparent: true,
        //         blending: THREE.AdditiveBlending,
        //         color: 0x666600,
        //         size: 0.25,
        //         opacity: 0.7,
        //         depthTest: true,
        //         depthWrite: true
        //     }),
        // }
        //
        // pg_material.points.map = pg_material.map();
        //
        // PG.setAttribute('position', new THREE.BufferAttribute(label.pos, 3));
        // PG.name = 'label_guide';
        //
        // label._points = new THREE.Points(PG, pg_material.points);
        //
        // label.mesh = new THREE.Mesh(geometry, material);
        // label.mesh.receiveShadow = false;
        //
        //

        const material = new THREE.MeshBasicMaterial({
            transparent: true,
            blending: THREE.AdditiveBlending,
            opacity: 0.5,
            side: THREE.DoubleSide,
            map: label.texture,
            depthTest: false,
            depthWrite: false
        });

        const geometry = new THREE.PlaneGeometry(1,1);
        label.mesh = new THREE.Mesh(geometry, material);
        label.mesh.receiveShadow = false;

        //label.mesh.position.set(vars.view.scene_width/2+1.0,0,0);

        return label.mesh;
    }

    const label = {
        value: null,
        canvas: null,
        texture: null,
        mesh: null,
        font: 'px Arial',
        font_size: 64,
        size: 256,
        base_color: vars.view.colors.window_background_hex,
        color: '#FFFFFF',
        write,
        init_object
    }

    //console.log(label);
    return label;

}

const keys = {
    active: [],
    previous: []
}

const touch = {
    x: null,
    y: null,
    last: {
        x: 0,
        y: 0
    },
    delta: {
        x: 0,
        y: 0
    },
    origin: {
        x: 0,
        y: 0
    },
    origin_last: {
        x: 0,
        y: 0
    },
    origin_delta: {
        x: 0,
        y: 0
    }
};

function event_not_idle() {
    if (!LT_unit) return false;
    ray_caster.setFromCamera(user.mouse.raw, cam.camera);

    //const intersects = ray_caster.intersectObjects(scene.children, true);
    const intersects = ray_caster.intersectObject(LT_unit.all, true);

    let instance_id = null;
    let len = intersects.length;
    let ids = [];
    const ico = [];
    const edge = [];
    const capture = [];

    for (let i = 0; i < len; i++) {
        if (intersects[i].hasOwnProperty('instanceId')) {
            capture.push(intersects[i]);
            break;
        }
    }

    if (capture.length) {
        //LT_unit.selected = capture[0].instanceId;
        vars.selected_instance = Math.floor(capture[0].instanceId);
    }else{
        vars.selected_instance = null;
    }

    //
    // if (vars.evt.action === 'click' || vars.evt.action === 'up') {
    //     vars.clicked_id = null;
    // }
    //
    // if (capture.length) {
    //     //console.log(capture.instanceId);
    //     LT_unit.selecta = capture[0].instanceId;
    //     // if (capture[0].object.name === 'ball') {
    //     //
    //     //     // console.log(capture[0]);
    //     //
    //     //     capture[0].object.userData.m.bounce();
    //     // }
    //     // if (capture[0].object.name === 'lettuce_shell') {
    //     //     dank_lettuce.capture_event(capture[0]);
    //     // }
    //
    // }
    //
    //
    // // if (vars.evt.action !== 'down' && vars.evt.action !== 'drag') {
    // //     if (ico.length) {
    // //         face_helper.m.selected_mesh = ico[0].object;
    // //         face_helper.m.selected_face_index = ico[0].faceIndex;
    // //         face_helper.m.selected_face = ico[0].face;
    // //     } else {
    // //         face_helper.m.un_assign();
    // //     }
    // // }
    // //
    // // if (face_helper.m.selected_mesh !== null) {
    // //     face_helper.m.assign();
    // // }
    // //
    // // if (edge.length) {
    // //     obs.innerHTML = edge[0].object.userData.info;///Object.entries(edge[0]).map(k => k+'</br>');
    // // }
    //
    // if (ids.length) vars.selected_id = ids[0];

}

function event_handler(type, evt_object) {
    //this is asynchronus to current rendering frame;
    let action, roto_x, roto_y, pos_x, pos_y, delta_x, delta_y, scale_z;
    delta_x = null;
    delta_y = null;

    if (type === 'init') {
        pos_x = vars.view.width / 2;
        pos_y = vars.view.height / 2;
    }

    if (type === 'touch') {
        action = evt_object.action;
        const primary = evt_object.touches[0];
        if (evt_object.touches.length > 1) {
            const secondary = evt_object.touches[1];
            const x_o = primary.x - secondary.x;
            const y_o = primary.y - secondary.y;
            touch.last.x = touch.x;
            touch.last.y = touch.y;
            touch.x = primary.x - (x_o / 2);
            touch.y = primary.y - (y_o / 2);
            touch.delta.x = touch.last.x === null ? 0 : touch.x - touch.last.x;
            touch.delta.y = touch.last.y === null ? 0 : touch.y - touch.last.y;

            if (evt_object.action === 'secondary-down') {
                touch.origin.x = touch.x;
                touch.origin.y = touch.y;
            }

            touch.origin_delta.x = touch.origin_last.x - (touch.origin.x - touch.x);
            touch.origin_delta.y = touch.origin_last.y - (touch.origin.y - touch.y);
            touch.origin_last.x = touch.origin.x - touch.x;
            touch.origin_last.y = touch.origin.y - touch.y;

            roto_x = evt_object.angle_delta;
            roto_y = touch.origin_delta.y / 100.0;
            pos_x = touch.x;
            pos_y = touch.y;
            delta_x = touch.delta.x;
            delta_y = touch.delta.y;
            scale_z = 1.0 + evt_object.dist_delta;

        } else if (evt_object.touches.length === 1) {
            pos_x = primary.x;
            pos_y = primary.y;
            delta_x = primary.x_d;
            delta_y = primary.y_d;
            touch.x = null;
            touch.y = null;
        } else {
            pos_x = evt_object.x;
            pos_y = evt_object.y;
        }

    } else if (type !== 'init') {
        pos_x = evt_object.actual.x;
        pos_y = evt_object.actual.y;
        action = type;

        if (evt_object.down === true) {
            if (evt_object.button === 2 || keys.active.includes('ShiftLeft') || keys.active.includes('ShiftRight')) {
                roto_x = evt_object.delta.x / vars.evt_reactivity;
                roto_y = evt_object.delta.y / vars.evt_reactivity;
            } else {
                delta_x = evt_object.delta.x;
                delta_y = evt_object.delta.y;
            }
        }
        if (action === 'scroll') {
            scale_z = 1 + (evt_object.wheel_delta.y / vars.evt_reactivity);
        }
    }

    // if (action === 'down' || action === 'secondary-down' || action === 'secondary-up') {
    //     user.mouse.delta_pos.set(pos_x, pos_y, 0.0);
    // }
    //
    // if (delta_x !== null || delta_y !== null) {
    //     user.mouse.delta_pos.set(user.mouse.delta_pos.x + delta_x, user.mouse.delta_pos.y + delta_y, 0.0);
    //     pos_x = user.mouse.delta_pos.x;
    //     pos_y = user.mouse.delta_pos.y;
    // }

    user.mouse.state = action;
    user.mouse.raw.x = (pos_x / vars.view.width) * 2 - 1;
    user.mouse.raw.y = -(pos_y / vars.view.height) * 2 + 1;
    //user.mouse.raw.z = 0.0;
    //user.mouse.screen = {x: pos_x, y: pos_y};

    cam.scale = 1 - (cam.distance / cam.default_reset_z);

    //#//DRAG depends on camera being set, hence the latency.
    //#//when the camera is being reset...

    ray_caster.setFromCamera(user.mouse.raw, cam.camera);
    ray_caster.ray.intersectPlane(root_plane, user.mouse.plane_pos);


    if (action === 'down' || action === 'secondary-down' || action === 'secondary-up') {
        //user.mouse.delta_pos.set(pos_x, pos_y, 0.0);
        user.mouse.last_down.copy(user.mouse.plane_pos);
        user.mouse.origin_pos.copy(model.position);
    }

    if (roto_x || roto_y) {
        cam.cube.rotateOnWorldAxis(y_up, roto_x);
        cam.cube.rotateX(roto_y);
        cam.cube.updateMatrixWorld();
    }

    if (delta_x !== null || delta_y !== null) {
        //user.mouse.delta_pos.set(user.mouse.delta_pos.x+delta_x, user.mouse.delta_pos.y+delta_y, 0.0);
        //user.mouse.delta_pos.set(delta_x, delta_y, 0.0);

        user.mouse.new_down.copy(user.mouse.plane_pos);//.multiplyScalar(0.25));
        user.position.dvl.copy(user.mouse.new_down.sub(user.mouse.last_down));

        //if(user.position.dvl.length() > 0.0){
        model.position.copy(user.position.dvl.add(user.mouse.origin_pos));
            //user.position.actual.sub(user.position.dvl);
        //}
    }





    if (scale_z && vars.view.zooms) {
        if (cam.base_pos.z < cam.min_zoom) {
            cam.base_pos.z = cam.min_zoom;
        } else {
            cam.base_pos.multiplyScalar(scale_z);
            vk.copy(user.mouse.plane_pos).negate();
            model.position.add(vk.multiplyScalar((1 - scale_z)));
        }
    }

    //objects.arrow.position.copy(user.mouse.plane_pos).setY(0.5);

    if (vars.view.show_user) user.show();

    cam.run();

    vk.subVectors(user.mouse.plane_pos, model.position);

    user.mouse.map_pos.copy(model.position).setY(20.0);

    vars.events.action = action;


    //user.mouse.map_pos.set(-model.position.x, vars.view.scene_width/2.0, -model.position.z).applyMatrix4(cam.camera.matrixWorldInverse);//projectionMatrixInverse);

    //view_user.grid_lines.segments[0][0].material.uniforms.modelPosition.value = user.mouse.map_pos;// (user.mouse.map_pos);
    // view_user.grid_lines.segments[0][1].material.uniforms.modelPosition.value = (user.mouse.map_pos);

    //light.target.setX(model.position.x*-1);//(0, vars.view.scene_width * 3, 0);
    //.setZ(model.position.z*-1);
    //renderer.render(scene, cam.camera);
}

const directions = {'KeyW':[0,1],'KeyS':[0,-1],'KeyA':[1,-1],'KeyD':[1,1]};

function user_move(method){
    const ptr = [0,0,0];
    for(let k of method) ptr[k[0]] = k[1];
    vu.fromArray(ptr);

    vk.copy(cam.direction).multiplyScalar(ptr[0]*0.1);
    user.position.actual.add(vk);

    vk.copy(cam.right).multiplyScalar(ptr[1]*0.1);
    user.position.actual.add(vk);

    cam.run();
    user.show();

    objects.arrow.position.copy(user.position.actual);//.setY(UU.inter.rad);
}

function keyAction(raw) {
    keys.active = raw;
    // console.log(raw);

    if (raw.includes('Space')) {

    }

    if (raw.includes('Tab')) {
        if (!keys.previous.includes('Tab')) {
            user.toggle_state();//toggle_debug_tools_state();
        }
    }

    if (raw.includes('ArrowUp')) {
        cam.camera.getWorldDirection(vu);
        vars.pos.add(vu);
        cam.run();
        //alert('up');
    }

    if (raw.includes('ArrowDown')) {
        cam.camera.getWorldDirection(vu);
        vars.pos.sub(vu);
        cam.run();
        //alert('up');
    }

    if (raw.includes('KeyL')) {
        LT_unit.inter.height -= 0.1;
    }

    if (raw.includes('KeyO')) {
        LT_unit.inter.height += 0.1;
    }

    if (raw.includes('KeyK')) {
        LT_unit.inter.rad -= 0.1;
    }

    if (raw.includes('KeyI')) {
        LT_unit.inter.rad += 0.1;
    }

    if(raw.includes('KeyP')){
        const points = [];
        for(let u=0;u<LT_unit.sectors.list[0].length;u++){
            const p_i = LT_unit.sectors.list[0][u];
            points.push([LT_unit.pos[p_i*3], LT_unit.pos[p_i*3+1], LT_unit.pos[p_i*3+2]]);
        }
        const cells = alphaShape(0.5, points);
        console.log(cells);
    }

    if(raw.includes('Space')) {
        if (!keys.previous.includes('Space')) {
            LT_unit.stopped = !LT_unit.stopped;
            vars.paused = LT_unit.stopped;
        }
    }

    if(raw.includes('Digit1')) {
        if (!keys.previous.includes('Digit1')) {
            LT_unit.decorate = !LT_unit.decorate;
            LT_unit.box_help.map(b => {
                b.visible = false;
            });
        }
    }

    if(raw.includes('Digit2')) {
        if (!keys.previous.includes('Digit2')) {
            LT_unit.inter.on = !LT_unit.inter.on;
        }
    }

    const kr = Object.keys(directions).filter(k=>keys.active.includes(k)).map(k=>directions[k]);
    if(kr.length) user_move(kr);

    keys.previous = [...keys.active];
}

function init_view() {
    model = new THREE.Group();


    //scene.add( plane_helper );
    //scene.add( cam.cube );

    console.log('init view');

    const v_size = vars.view.scene_width;
    const Color = new THREE.Color();

    function make_pointer_arrow() {
        let points = [];
        const raw_points = [
            0, 0,
            10, 20,
            6, 20,
            7, 32,
            0, 32
        ];

        for (let e = 0; e < raw_points.length; e += 2) {
            points.push(new THREE.Vector2(raw_points[e], raw_points[e + 1]));
        }

        const a_geometry = new THREE.LatheGeometry(points, 20);
        const a_material = new THREE.MeshStandardMaterial({
            color: 0xFF3300,
            side: THREE.FrontSide,
            flatShading: true,
            roughness: 0,
            metalness: 0.25,
            emissive: 0x161616
        });
        //const a_material = new MeshStandardMaterial( { color: 0xffff00 } );
        a_geometry.translate(0, -32, 0);
        a_geometry.rotateX(Math.PI / 2);
        a_geometry.scale(0.02, 0.02, 0.02);
        a_geometry.name = 'make_pointer_arrow';
        const arrow = new THREE.Mesh(a_geometry, a_material);
        arrow.userData.base_color = arrow.material.color;
        arrow.material.needsUpdate = true;

        //arrow.scale.set(0.02, 0.02, 0.02);

        return arrow;

    }

    function make_ball() {

        function init(){

            //const t_ball = new THREE.Group();
            const a_geometry = new THREE.SphereBufferGeometry(1.0);
            const a_material = new THREE.MeshStandardMaterial({
                color: 0x333333,
                side: THREE.FrontSide,
                flatShading: false,
                roughness: 0,
                metalness: 0.25,
                emissive: 0x161616,
                transparent: true,
                opacity: 0.25,
                // depthTest: true,
                // depthWrite: true
            });





            const curve = new THREE.EllipseCurve(
              0.0, 0.0,            // Center x, y
              1.0, 1.0,          // x radius, y radius
              0.0, 2.0 * Math.PI,  // Start angle, stop angle
            );

            const pts = curve.getSpacedPoints(256);
            const geometry = new THREE.BufferGeometry().setFromPoints(pts);

            const mat = new THREE.LineBasicMaterial({
                color: vars.view.helper_color,
                blending: THREE.AdditiveBlending,
                transparent: true,
                depthWrite: false
            });
            //const circle = new THREE.LineLoop(geometry, mat);
            //scene.add(circle);



            ball.circle_z = new THREE.LineLoop(geometry, mat);

            const x_geometry = geometry.clone().rotateY(Math.PI / 2);
            ball.circle_x = new THREE.LineLoop(x_geometry, mat);

            const y_geometry = geometry.clone().rotateX(Math.PI / 2);
            ball.circle_y = new THREE.LineLoop(y_geometry, mat);


            ball.sphere = new THREE.Mesh(a_geometry, a_material.clone());

            ball.body = new THREE.Group();
            ball.body.add(ball.circle_x);
            ball.body.add(ball.circle_y);
            ball.body.add(ball.circle_z);

            //ball.body.add(ball.sphere);

            // t_ball.userData.update = function(y_inter=null){
            //     alert(this);
            // };



        }

        function init_planes(dims){
            ball.planes = [
                new THREE.Plane( new THREE.Vector3( - 1, 0, 0 ), vars.view.scene_width/2 ),
                new THREE.Plane( new THREE.Vector3( 0, 1, 0 ), 0 ),
                new THREE.Plane( new THREE.Vector3( 0, 0, - 1 ), vars.view.scene_width/2 ),
                new THREE.Plane( new THREE.Vector3( 1, 0, 0 ), vars.view.scene_width/2 ),
                new THREE.Plane( new THREE.Vector3( 0, 0, 1 ), vars.view.scene_width/2 ),
                // new THREE.Plane( new THREE.Vector3( 1, 0, 0 ), -10 ),
                // new THREE.Plane( new THREE.Vector3( 0, 1, 0 ), -10 ),
                // new THREE.Plane( new THREE.Vector3( 0, 0, 1 ), -10 )
            ];

            const material = new THREE.MeshStandardMaterial({
                color: 0x666666,
                clippingPlanes: ball.planes,
                side: THREE.DoubleSide,
                metalness: 0.1,
                roughness: 0.75,
                transparent: true,
                opacity: 0.4
            });

            // ball.sphere.material = material;
            const t_sphere = new THREE.Mesh( ball.sphere.geometry, material );
            t_sphere.receiveShadow = true;
            // clippedColorFront.castShadow = true;
            // clippedColorFront.renderOrder = 12;
            ball.body.add( t_sphere );

            /*
            // Set up clip plane rendering
            ball.planeObjects = [];
            const planeGeom = new THREE.PlaneGeometry( 20, 20 );

            for ( let i = 0; i < 5; i ++ ) {

                const poGroup = new THREE.Group();
                const plane = ball.planes[ i ];
                const stencilGroup = createPlaneStencilGroup( ball.sphere.geometry, plane, i + 1 );

                // plane is clipped by the other clipping planes
                const planeMat =
                    new THREE.MeshStandardMaterial( {
                        color: 0xE91E63,
                        metalness: 0.1,
                        // transparent:true,
                        // opacity:0.6,
                        // depthTest:true,
                        // depthWrite:true,
                        // side: THREE.DoubleSide,
                        // blending: THREE.AdditiveBlending,
                        roughness: 0.75,
                        clippingPlanes: ball.planes.filter( p => p !== plane ),
                        stencilWrite: true,
                        stencilRef: 0,
                        stencilFunc: THREE.NotEqualStencilFunc,
                        stencilFail: THREE.ReplaceStencilOp,
                        stencilZFail: THREE.ReplaceStencilOp,
                        stencilZPass: THREE.ReplaceStencilOp,

                    } );

                const po = new THREE.Mesh( planeGeom, planeMat );
                po.onAfterRender = function ( renderer ) {
                    renderer.clearStencil();
                };

                po.renderOrder = i + 1.1;

                ball.body.add( stencilGroup );
                poGroup.add( po );

                ball.planeObjects.push( po );
                scene.add( poGroup );
                //ball.body.add( po );
            }


            const material = new THREE.MeshStandardMaterial( {
                color: 0xFFFF00,
                side: THREE.DoubleSide,
                metalness: 0.1,
                roughness: 0.75,
                clippingPlanes: ball.planes,
                clipShadows: true,
                shadowSide: THREE.DoubleSide,
            } );

            // add the color
            const clippedColorFront = new THREE.Mesh( ball.sphere.geometry, material );
            clippedColorFront.castShadow = true;
            clippedColorFront.renderOrder = 12;
            ball.body.add( clippedColorFront );
            */


            // for ( let i = 0; i < ball.planeObjects.length; i ++ ) {
            //
            //     const plane = ball.planes[ i ];
            //     const po = ball.planeObjects[ i ];
            //     plane.coplanarPoint( po.position );
            //     po.lookAt(
            //         po.position.x - plane.normal.x,
            //         po.position.y - plane.normal.y,
            //         po.position.z - plane.normal.z,
            //     );
            //
            // }


        }

        //pos.n/rad;
        function update(pos, rad, dims){
            ball.planes[0].constant = model.position.x + vars.view.scene_width / 2;
            ball.planes[3].constant = vars.view.scene_width / 2 - model.position.x;
            ball.planes[2].constant = model.position.z + vars.view.scene_width / 2;
            ball.planes[4].constant = vars.view.scene_width / 2 - model.position.z;

            ball.body.scale.setScalar(rad);
            for(let n = 0; n<ball.iter.length; n++){
                const _pos = ((dims[n])/rad) + (Math.abs(pos[ball.iter[n]])/rad);
                const n_r = 1.0 - (_pos*_pos);
                const o_r = quick_d(n_r) * n_r;
                ball['circle_'+ball.iter[n]].position[ball.iter[n]] = -(_pos*Math.sign(pos[ball.iter[n]]));
                ball['circle_'+ball.iter[n]].scale.setScalar(o_r);
            }

            ball.body.updateMatrixWorld();
            ball.sphere.geometry.computeBoundingSphere();
            ball.sphere.geometry.computeBoundingBox();
        }

        const ball = {
            iter:['x','y','z'],
            body:null,
            sphere: null,
            circle_x: null,
            circle_y: null,
            circle_z: null,
            planes:null,
            planeObjects:null,
            update:update
        }

        init();
        init_planes();
        //ball.update(0.5);
        //t_ball.userData.update();
        return ball;//
    }

    function make_grid_lines(size) {

        const uniforms = THREE.UniformsUtils.merge([
            THREE.UniformsLib['lights'],
            {
                color: {
                    type: 'c',
                    value: new THREE.Color(0x666666)
                },
                limitDistance: {
                    value: vars.view.scene_width/2
                }
            }
        ]);


        console.log(uniforms);

        const material = new THREE.ShaderMaterial({
            transparent: true,
            //blending: THREE.AdditiveBlending,
            depthTest: true,
            depthWrite: true,
            uniforms: uniforms,
            vertexShader: `
                varying vec3 vPos;
                varying vec3 vNormal;

                void main() {
                  vPos = position;
                  vNormal = normalMatrix * normal;
                  gl_Position = projectionMatrix * modelViewMatrix * vec4(position,1.0);
                }
            `,
            fragmentShader: `
                varying vec3 vPos;
                varying vec3 vNormal;
                uniform vec3 color;
                uniform float limitDistance;
                
                struct DirectionalLight {
                  vec3 direction;
                  vec3 color;
                };

                uniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];
                
                void main(){
                    vec3 norm = normalize(vNormal);
                    float nDotL = clamp(dot(directionalLights[0].direction, norm), 0.0, 1.0);
                    
                    vec4 diffuseColor = vec4(directionalLights[0].color, 1.0) * vec4(color, 1.0) * nDotL;
                    
                    float distance = clamp(length(vPos), 0., limitDistance);
                    float opacity = 1. - distance / limitDistance;
                
                    vec4 sideColor = mix(vec4(color, 1.0), vec4( color, 1.0) * diffuseColor, 0.8);
                    sideColor.w = opacity;
                
                
                    gl_FragColor = sideColor;
                }
                
            `,
            lights: true
        });

        const axis_line_group = new THREE.Group();
        const segments = [];

        const ralph = new THREE.Quaternion();
        const rad = 0.02;//1;
        for(let n = 0; n < 3; n++){

            const r = [0,0,0];
            r[2-n] = 1.0;

            vu.fromArray(r);
            const c = n === 0 ? 2 : -2;
            ralph.setFromAxisAngle(vu, Math.PI / c);


            const geometry = new THREE.CylinderGeometry( rad, rad, size, 16, 32 );
            geometry.translate(0,size/2,0);
            geometry.applyQuaternion(ralph);
            const neg = new THREE.Mesh( geometry, material );

            const n_geometry = geometry.clone();
            if(n === 1){
                n_geometry.rotateX(Math.PI);
            }else{
                ralph.setFromAxisAngle(vu, Math.PI);
                n_geometry.applyQuaternion(ralph);
            }

            const pos = new THREE.Mesh( n_geometry, material );


            segments.push(n === 1 ? [pos,neg] : [neg,pos]);


            axis_line_group.add(neg);
            axis_line_group.add(pos);
        }

        return {art:axis_line_group, segments:segments};

    }

    function make_pointer_arrow_instance_set() {

        //create image
        const bitmap = document.createElement('canvas');
        const g = bitmap.getContext('2d');
        bitmap.width = 1000;
        bitmap.height = 1000;
        g.fillStyle = '#f5eabf';
        g.fillRect(0, 0, bitmap.width, bitmap.height);
        // g.strokeStyle = 'black';
        // g.lineWidth = 10;
        //
        // g.beginPath();
        // g.moveTo(0, bitmap.height/2);
        // g.lineTo(bitmap.width, bitmap.height/2);
        // g.stroke();

        g.fillStyle = 'red';
        for (let i = 1; i < 10; i += 2) {
            g.fillRect(0, i * (bitmap.height / 9), bitmap.width, (bitmap.height / 9));
        }
        // g.beginPath();
        // g.moveTo(bitmap.width/2, 0);
        // g.lineTo(bitmap.width/2, bitmap.height);
        // g.stroke();

        // g.beginPath();
        // g.moveTo(250, 0);
        // g.lineTo(250, bitmap.height);
        // g.stroke();
        //
        // g.beginPath();
        // g.moveTo(750, 0);
        // g.lineTo(750, bitmap.height);
        // g.stroke();

        // g.fillStyle = 'white';
        // g.fillText(text, 0, 20);
        // g.strokeStyle = 'black';
        // g.strokeText(text, 0, 20);

        // canvas contents will be used for a texture
        const texture = new THREE.Texture(bitmap)
        texture.needsUpdate = true;


        const a_geometry = new THREE.SphereBufferGeometry(1);//,10,10);//points, 20);
        const a_material = new THREE.MeshStandardMaterial({
            // const a_material = new THREE.MeshStandardMaterial({
            color: 0x666666,
            side: THREE.FrontSide,
            // // gradientMap: false,
            // flatShading: true,
            roughness: 0,
            metalness: 0.25,
            emissive: 0x222200,
            // depthTest: true,
            // depthWrite: true,
            map: texture
        });

        // a_material.onBeforeCompile = function(stuff) {
        //     let chunk = THREE.ShaderChunk.shadowmap_pars_fragment
        //         .split ('z += shadowBias')
        //         .join ('z += shadowBias - 0.01');
        //     stuff.fragmentShader = stuff.fragmentShader
        //         .split ('#include <shadowmap_pars_fragment>')
        //         .join (chunk);
        // };

        //const a_material = new MeshStandardMaterial( { color: 0xffff00 } );
        //a_geometry.translate(0,-16,0);
        a_geometry.rotateX(Math.PI / 2);
        //a_geometry.scale(0.5, 0.5, 0.5);
        a_geometry.name = 'make_pointer_arrow_instance_set';

        const instance = new THREE.InstancedMesh(a_geometry, a_material, vars.particles._count.params.max);

        instance.instanceMatrix.setUsage(THREE.DynamicDrawUsage);

        instance.castShadow = true; //default is false
        instance.receiveShadow = true; //default

        return instance;
    }

    objects.arrow = make_pointer_arrow();
    objects.arrow.rotateX(Math.PI/-2);
    // objects.box = new THREE.BoxHelper(objects.arrow, 0x660000);

    objects.ball = make_ball();
    objects.ball.body.renderOrder = 2;

    // objects.a_help = new THREE.ArrowHelper();
    // objects.b_help = new THREE.ArrowHelper();
    // objects.c_help = new THREE.ArrowHelper();
    // objects.d_help = new THREE.ArrowHelper();
    //
    // objects.d_help.setColor(0xFFFFFF);


    // const points = [];
    // points.push(new THREE.Vector3(0, 0, 0));
    // points.push(new THREE.Vector3(4, 0, 0));
    // points.push(new THREE.Vector3(0, 0, 0));
    // points.push(new THREE.Vector3(4, 0, 0));
    // points.push(new THREE.Vector3(0, 0, 0));
    // points.push(new THREE.Vector3(4, 0, 0));
    // const line_material = new THREE.LineBasicMaterial({color: 0xFF0000})
    // const line_geometry = new THREE.BufferGeometry().setFromPoints(points);
    // objects.test_line = new THREE.LineSegments(line_geometry, line_material);
    //
    //




    // const light2 = new THREE.PointLight(0xFFFF00, 0.25, -20);
    // light2.position.set(0, 0, 0);
    // light2.castShadow = false;
    //
    // objects.lite = light2;


    view_user = new THREE.Group();

    view_user.grid_lines = make_grid_lines(v_size);

    //grid_lines.position.setY(0.01);
    view_user.add(view_user.grid_lines.art);



    const view_user_labels = ['x','y','z'];
    view_user.labels = [];


    for(let n=0;n<3;n++){
        const k = [0,0,0];
        k[n] = 4.0;
        const m_label = scene_label();
        view_user.labels.push(m_label);
        view_user.add(m_label.init_object());

        m_label.write(view_user_labels[n]);
        m_label.value = view_user_labels[n];
        m_label.mesh.position.set(k[0],k[1],k[2]);
        view_user.add(m_label.mesh);

        //
        // view_user.add(m_label._points);
        //
        //
        // view_user.add(m_label.marker);
        // view_user.add(m_label.marker2);
        //
        // // const m_group = new THREE.Group();
        // // view_user.add(m_label.marker);
        // // view_user.add(m_label.marker2);
        // //
        // objects.marks.push(m_label);
        //
        // m_label.marker.position.set(k[0],k[1],k[2]);
        // m_label.marker2.position.set(k[0],k[1],k[2]);
        //
        // view_user.add(m_label.cube);
        // m_label.cube.position.set(k[0],k[1],k[2]);
        //
        // m_label._points.position.set(k[0],k[1],k[2]);
        // m_label.mesh_back.renderOrder = -1;
    }


    objects.group = new THREE.Group();
    objects.group.add(objects.arrow, objects.ball.body);//, objects.lite);
    //objects.group.add(objects.arrow, objects.box, objects.ball.body, objects.a_help, objects.b_help, objects.c_help, objects.d_help);//, objects.lite);

    //scene.add(objects.arrows_all);
    model.add(objects.group);


    // view_user.labels[0].mesh.rotateX(Math.PI/-2);
    // view_user.labels[2].mesh.rotateX(Math.PI/-2);

    // scene.add(m_label.init_object());
    // m_label.write('ok');
    //

    view_user.position.copy(vars.view.start_user_pos);//user.position.actual;
    view_user.renderOrder = 0;
    scene.add(view_user);


    view_axes = new THREE.AxesHelper(vars.view.scene_width / 2);
    view_axes.material.blending = THREE.AdditiveBlending;
    view_axes.material.transparent = true;
    model.add(view_axes);

    view_bounds = new THREE.Group();
    const r = vars.view.scene_width;
    const bounds_box = new THREE.Mesh(new THREE.BoxGeometry(r, r, r));
    bounds_box.position.setY(r/2);
    const helper = new THREE.BoxHelper(bounds_box);

    helper.material.color.setHex(vars.view.helper_color);
    helper.material.blending = THREE.AdditiveBlending;
    helper.material.transparent = true;
    view_bounds.add(helper);
    model.add(view_bounds);

    //Color.set(vars.view.helper_color).offsetHSL(0, 0, 0.1);
    Color.set(vars.view.helper_color);//.offsetHSL(0, 0, 0.3);

    const col_xy = Color;///new THREE.Color("hsl(100, 0%, 35%)");
    const col_gd = Color;//vars.view.helper_color;//new THREE.Color("hsl(100, 0%, 30%)");
    view_grid = new THREE.GridHelper(r, r, col_xy, col_gd);
    view_grid.material.blending = THREE.AdditiveBlending;
    view_grid.material.transparent = true;
    view_grid.renderOrder = 1;
    model.add(view_grid);

    //create image
    const text = vars.plane_text;//'sandwich — as a collection of reorganizable particles.';
    const bitmap = document.createElement('canvas');
    const g = bitmap.getContext('2d');
    bitmap.width = 2056;
    bitmap.height = 2056;
    g.font = '64px Arial';
    g.fillStyle = '#333333';
    g.fillRect(0, 0, bitmap.width, bitmap.height);

    g.fillStyle = 'white';
    g.fillText(text, 8, 64);
    // g.strokeStyle = 'black';
    // g.strokeText(text, 0, 20);

    // canvas contents will be used for a texture
    const texture = new THREE.Texture(bitmap)
    texture.needsUpdate = true;

    const geometry = new THREE.PlaneGeometry(vars.view.scene_width, vars.view.scene_width);
    const material = new THREE.MeshLambertMaterial({
        color: 0xffffff,
        transparent: true,
        opacity: 0.25,
        side: THREE.DoubleSide,
        map: texture,
        depthTest: true,
        depthWrite: true
    });

    r_root_plane = new THREE.Mesh(geometry, material);
    r_root_plane.rotateX(Math.PI / -2);
    r_root_plane.receiveShadow = true;
    //r_root_plane.renderOrder = 0;

    model.add(r_root_plane);
    model.renderOrder = 1;


    scene.add(model);

    light.target = model;

}

function init() {
    vars.selected_instance = 0;
    vars.static_connect = 0;

    vars.view.width = window.innerWidth;
    vars.view.height = window.innerHeight;

    //cam.camera = new THREE.OrthographicCamera( vars.view.width / - 100, vars.view.width / 100, vars.view.height / 100, vars.view.height / - 100, 1, 1000 );
    cam.camera = new THREE.PerspectiveCamera(60, vars.view.width / vars.view.height, 0.1, 300);
    scene = new THREE.Scene();
    scene.background = new THREE.Color(vars.view.colors.window_background);

    renderer = new THREE.WebGLRenderer({
        powerPreference: "high-performance",
        antialias: true
    });
    renderer.setPixelRatio(1);
    renderer.setSize(vars.view.width, vars.view.height-24);
    //renderer.setClearColor(0x000000);


    renderer.shadowMap.enabled = true;
    renderer.shadowMap.type = THREE.PCFSoftShadowMap; //THREE.VSMShadowMap;//
    //renderer.shadowMap.blurSamples = 4;
    //

    renderer.localClippingEnabled = true;


    root_plane = new THREE.Plane(y_up);
    // scene.add(root_plane);

    //const light = new THREE.PointLight(0xffffff, 1, 200);
    light = new THREE.DirectionalLight(0xffffff, 1);
    light.position.set(0, vars.view.scene_width/2, 0);

    light.castShadow = true; // default false


    //Set up shadow properties for the light
    light.shadow.mapSize.width = 1024; // default
    light.shadow.mapSize.height = 1024; // default
    light.shadow.camera.near = 0.5; // default
    light.shadow.camera.far = 500; // default
    light.shadow.radius = 16;
    light.shadow.blurSamples = 25;
    //light.shadow.bias = -0.1;
    //
    // light.shadow.blurSamples = 25

    light.shadow.camera.left = -vars.view.scene_width;
    light.shadow.camera.right = vars.view.scene_width;
    light.shadow.camera.top = vars.view.scene_width;
    light.shadow.camera.bottom = -vars.view.scene_width;




    scene.add(light);
    scene.add(light.target);

    // const helper = new THREE.CameraHelper( light.shadow.camera );
    // scene.add( helper );

    // const light2 = new THREE.PointLight(0xFF6600, 1, -20);
    // light2.position.set(0, -vars.view.scene_width, 0);
    // light2.castShadow = false;
    // scene.add(light2);

    const light3 = new THREE.AmbientLight(vars.view.colors.window_background); // soft white light
    scene.add(light3);
    // stats = new Stats();
    // stats.dom.style.opacity = '0.2';
    // document.body.appendChild(stats.dom);

    vars.events = {};
    vars.events.action = null;
    dragControls(renderer.domElement, event_handler, vars.events);

    keyControls(window, keyAction, vars.events);

    const target = document.getElementById('module-window');
    target.appendChild(renderer.domElement);

    // const visible_dimensions = visibleAtZDepth(-cam.default_z, cam.camera);
    // cam.base_pos.z = ((cam.default_z / visible_dimensions.h) * vars.view.scene_width) + 10.0;
    // cam.default_reset_z = cam.base_pos.z;
    // cam.scale = 1 - (cam.distance / cam.default_reset_z);

    ray_caster.params.Line.threshold = 0.005;
    ray_caster.params.Points.threshold = 0.025;

    cam.run();



    // scene.fog = new THREE.Fog(vars.view.colors.window_background, 5, 50);
    //scene.add(fog);

}

function post_init() {
    init_view();
    LT_unit = units();
    LT_unit.stopped = vars.paused;
    view_grid.visible = vars.view.show_grid;
    view_axes.visible = vars.view.show_axes;
    view_bounds.visible = vars.view.show_bounds;
    r_root_plane.visible = vars.view.show_plane;
    view_user.visible = vars.view.show_user;
}

function render(a) {
    const k_delta = () => {
        const d = new Date();
        const l_delta = d - render_l_date;
        render_l_date = d;
        return Math.floor(1000 / l_delta);
    }
    const get_k = k_delta();
    if (vars.render_frame % 10 === 0) vars.fps = get_k;
    if (LT_unit){
        LT_unit.move();
    }
    event_not_idle();




    renderer.render(scene, cam.camera);
}

function animate(f) {
    vars.render_frame = window.requestAnimationFrame(animate);
    render(f);
}

const callbacks = {
    view_window_background: (value) => {
        scene.background = new THREE.Color(value);
    },
    view_show_grid: (value) => {
        view_grid.visible = value;
    },
    view_show_axes: (value) => {
        view_axes.visible = value;
    },
    view_show_bounds: (value) => {
        view_bounds.visible = value;
    },
    view_show_plane: (value) => {
        r_root_plane.visible = value;
    },
    view_show_user: (value) => {
        if (value) user.show();
        view_user.visible = value;
    },
    particles_count: (value) => {
        //particles_points.geometry.setDrawRange(0, value);
        objects.arrows_all.count = vars.particles.count;
        reorder();
    },
    particles_diameter: (value) => {
        particles_points.material.size = value;
        const pts = particles_points.userData.points;

        //pts.map()
        for (let e = 0; e < vars.particles.count; e++) {
            pts[e].radius = pts[e].set_radius()
            pts[e].reset();
        }

        //reorder();


    },
    paused: (value) => {
        paused_checkbox.element_event(null, value);
        LT_unit.stopped = value;
    },
    gravity: (value) => {
        gravity_checkbox.element_event(null, value);
        LT_unit.gravity_on = value;
    },
}

function menu_callback(tgt, prop, value) {
    if (callbacks.hasOwnProperty(tgt.menuname + '_' + prop)) callbacks[tgt.menuname + '_' + prop](value);
    if (callbacks.hasOwnProperty(prop)) callbacks[prop](value);
}

init();
post_init();

user.show();

animate(null);
const menu_ref = menu.init('variables', vars, obs_menu, menu_callback);

const el = document.querySelectorAll(`div[data-parent="root"]`)[0];
el.setAttribute('data-open','0');
menu.refresh_list();